<template>
  <div :class="{'col-sm-6': $route.name === 'medtastic.event_detail' || $route.name === 'medtastic.event_registration' || $route.name === 'medtastic.event_thanks'}"
       class="col-12 text-left text-sm-right pt-5 pb-5 text-white">
    <div class="text-1">{{ $t('medtastic.footer_contact_text') }}</div>
    <div class="text-2 text-white">medtastic GmbH<br>
      Bürglistrasse 8 | 8002 Zürich <br>
      <a href="tel:044 552 25 45">044 552 25 45</a> |
      <a href="mailto:contact@medtastic.ch" target="_blank">contact@medtastic.ch</a>
    </div>
    <div class="text-3">
      <router-link :to="{ name: 'medtastic.contact'}">{{ $t('medtastic.contact') }}</router-link> |
      <router-link :to="{ name: 'medtastic.impressum'}">{{ $t('medtastic.impressum') }}</router-link> |
      <a href="/documents/data-privacy.pdf"
         target="_blank">{{ $t('medtastic.data_privacy_statement') }}</a>
    </div>
  </div>
</template>

<script>
export default {
  layout: 'user'
}
</script>
